import clsx from 'clsx'
import React, { FunctionComponent, ReactNode } from 'react'
import styles from './InfoBar.module.scss'

export interface InfoBarProps {
  extra?: ReactNode
  className?: string
  divider?: boolean
  children?: ReactNode
}

export const InfoBar: FunctionComponent<InfoBarProps> = ({ children, extra, className, divider = true }) => {
  return (
    <div className={clsx(styles['info-bar'], !divider && styles['no-divider'], className)}>
      {children && (<div className={styles['info-bar-body']}>{children}</div>)}
      {extra && (<div className={styles['info-bar-extra']}>{extra}</div>)}
    </div>
  )
}
